<script>


import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getAuthorizationsToGroup, unlockGroup, saveAuthorizationsToGroup } from '@/services/serviceGroup';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'GroupAuthorization',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'groupId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["groupId","changeRecord"],
	data() {
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			basicData:[],
			mods:[]
			
		}
	},
	
	mounted:function(){
		
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){
			
			this.isLoading=true

			getAuthorizationsToGroup({groupId:this.groupId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.metaData = response.metaData;
					this.mods = response.mods;
					this.basicData = response.basicData;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},
		
				
		
		onSave:function(){

			this.isSending=true

			saveAuthorizationsToGroup({authorizations:this.mods,groupId:this.groupId}).then(response => {
				if(!response.statusText){
					this.isSending=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.$emit('changeRecord', '')
						this.mods = [];
						this.modalObject.hide();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==2){
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				}else{
					this.isSending=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
				
		},
		
		onClose:function(){
			if(this.groupId!='null'){
				unlockGroup({groupId:this.groupId}).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},
		
		
	},
	
	watch: {
		groupId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
	
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-fullscreen modal-dialog-scrollable">
			<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.Group') }} <b><span>{{ basicData.title }}</span></b></h6>
				</div>
		
				<div v-if="metaData.modulAccess && (auth.groupsChangeAuths)" class="modal-body">
				
					<div class="row">
						<div class="col-12">
							<p>Oprávnenia</p>
						</div>	
					</div>	
					
					<div class="row">
						
							<div class="col-12 col-md-3 col-lg-2 mb-5" v-for="(mod) in mods" :key="mod">
								<p><b>{{mod.title}}</b></p>
								
								<div   v-for="(authorization) in mod.authorizations" :key="authorization" class="togglebutton">
									<label>
										<input v-model='authorization.isSelected' type="checkbox">
										<span class="toggle"></span>
										{{authorization.title}}
									</label>
								</div>
							</div>
						
					</div>
					
				</div>
				
				<div v-else class="modal-body">
					<div class="row">
						<div class="col-12 mt-3">
							<Alert type="warning" :label="$t('msgCore.accessDenied')" />
						</div>
					</div>
				</div>
				
				<div class="modal-footer">
				
					<div class="btn-group">
						<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
						
						<LoadingButton :isDisabled="(!auth.groupsChangeAuths || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
					</div>	
					
				</div>
			
				
			
			</div>

		</div>
		
	</div>
	
</div>
		
		
</template>


